import {createStore, combineReducers, applyMiddleware, compose} from 'redux'
import {reducer as formReducer} from 'redux-form'

import thunk from 'redux-thunk';

const reducers = {
    form: formReducer,
    countries : (state = { options : [] }, action) => {
        if(action.type === "COUNTRY_LIST_LOAD")
            return { options : action.options };
        return state;
    },
    applicationErrors : (state = { submitted : false } , action ) => {
        if(action.type === "FORM_SUBMISSION_ERROR"){
            return action.error;
        }
        if(action.type === "CLEAR_ALL_ERRORS"){
            return {submitted:false}
        }
        return state;
    },
};

const reducer = combineReducers(reducers);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers( applyMiddleware(thunk) ) );


export {
    store,
    reducer
}
